import './Hero.css';
import { smoothScrollTo } from '../utils/smoothScroll';

function Hero() {
  return (
    <section id="anasayfa" className="hero">
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />

      <div className="hero__badge">
        <span className="hero__badge-dot" />
        7/24 Acil Servis Aktif
      </div>

      <p className="hero__eyebrow">Kağıthane · İstanbul</p>

      <h1 className="hero__title">
        <span className="hero__title--filled">AKIŞ</span>
        <span className="hero__title--accent">TESİSAT</span>
      </h1>

      <p className="hero__desc">
        Kameralı su kaçağı tespiti, tıkanıklık açma ve tesisat tadilat hizmetlerinde
        İstanbul'un güvenilir adresi.
      </p>

      <div className="hero__actions">
        <button className="hero__btn hero__btn--primary" onClick={() => smoothScrollTo('iletisim')}>
          Hemen Ara →
        </button>
        <button className="hero__btn hero__btn--secondary" onClick={() => smoothScrollTo('hizmetler')}>
          Hizmetlerimiz
        </button>
      </div>

      <div className="hero__scroll">
        <div className="hero__scroll-line" />
        Kaydır
      </div>

      <div className="hero__fade" />
    </section>
  );
}

export default Hero;
